var App = App || {};

App.RelatedNewsArticle = (function ($) {
    'use strict';

    function init() {
        function equalizeCardHeights() {
            let maxHeight = 0;
            $(".news-article-slider .article-card").each(function () {
                $(this).css("height", "auto");
                let thisHeight = $(this).outerHeight();
                if (thisHeight > maxHeight) {
                    maxHeight = thisHeight;
                }
            });
            $(".news-article-slider .article-card").css("height", maxHeight + "px");
        }

        function initializeSlick() {
            let articleCount = $(".news-article-slider .article-card").length;
            let showArrows = articleCount > 3;

            $(".news-article-slider").slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: showArrows,
                infinite: true,
                appendArrows: $('.news-article-slider'),
                prevArrow: '<button class="slick-prev" aria-label="Previous Article"><i class="fa-solid fa-arrow-left"></i></button>',
                nextArrow: '<button class="slick-next" aria-label="Next Article"><i class="fa-solid fa-arrow-right"></i></button>',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });

            $(".news-article-slider .slick-prev").after($(".news-article-slider .slick-next"));
        }

        $(".news-article-slider").on("setPosition", function () {
            equalizeCardHeights();
        });

        $(window).on("resize", function () {
            setTimeout(equalizeCardHeights, 300);
        });

        initializeSlick();
        equalizeCardHeights();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.RelatedNewsArticle.init();
});
